module.exports = __webpack_public_path__ + "static/media/condition_monitoring.d270eda5.png";